import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { NgxMercadopagoService } from 'ngx-mercadopago';
import { WhiteSpaceValidator } from 'src/app/validators/white-space-validator';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit {

  docTypes: DocumentType[] = [];

  form = this.fb.group({
    docType: ['', [Validators.required]],
    docNumber: ['', Validators.compose([
      Validators.required,
      Validators.pattern('[0-9]{8}')
    ])],
    cardholderName: ['', Validators.compose([
      Validators.required,
      WhiteSpaceValidator.cannotStartWithEmptyString,
      WhiteSpaceValidator.cannotFinishWithEmptyString,
      Validators.minLength(3)
    ])],
    cardExpirationYear: ['', Validators.compose([
      Validators.required,
      Validators.pattern('[0-9]{2}')
    ])],
    cardExpirationMonth: ['', Validators.compose([
      Validators.required,
      Validators.pattern('[0-9]{2}')
    ])],
    cardNumber: ['', Validators.compose([
      Validators.required,
      Validators.pattern('[0-9]{16}')
    ])],
    securityCode: ['', Validators.compose([
      Validators.required,
      Validators.pattern('[0-9]{3,4}')
    ])],
  });

  errorMap = {
    "324": "docNumber",
    "325": "cardExpirationMonth",
    "326": "cardExpirationYear",
    "E301": "cardNumber",
    "E302": "securityCode",
  }

  constructor(
    private ngxMpService: NgxMercadopagoService,
    private fb: FormBuilder,
    private modalController: ModalController,
    private loadingController: LoadingController,
  ) { }

  async ngOnInit() {

    await this.ngxMpService.initialize();

    this.ngxMpService.getIdentificationTypes().subscribe(response => {
      this.docTypes = response.data;
    });
  }

  async next(form: any) {

    const loader = await this.loadingController.create({
      message: 'Realizando pago..',
    });

    try {

      await loader.present();

      const res = await this.ngxMpService.createToken(form).toPromise();

      if (res.status === 400) {
        res.error.cause.map(({ code }) => {

          const field = this.errorMap[code];

          if (field)
            this.form.controls[field].setErrors({ 'invalid': true });
        });

      } else if (res.status === 200) {

        const { data: cardToken } = res;

        const { first_six_digits } = res.data;

        const paymentMethods = await this.ngxMpService.getPaymentMethod({
          bin: first_six_digits
        }).toPromise();

        const { data: [paymentMethod], status } = paymentMethods;

        if (status === 200) {

          const payData = {
            token: cardToken.id,
            paymentMethodId: paymentMethod.id,
            payerDocType: cardToken.cardholder.identification.type,
            payerDocNumber: cardToken.cardholder.identification.number
          }

          this.modalController.dismiss({
            payData
          });
        }
      }
      else
        alert("Ocurrio un error inesperado")

      await loader.dismiss();

    } catch (e) {

      console.log("Exception: ", e);
      await loader.dismiss();
    }
  }

  dismiss() {

    this.modalController.dismiss({
      payData: null
    });
  }

  get docType() {
    return this.form.get('docType');
  }

  get docNumber() {
    return this.form.get('docNumber');
  }

  get cardholderName() {
    return this.form.get('cardholderName');
  }

  get cardExpirationYear() {
    return this.form.get('cardExpirationYear');
  }

  get cardExpirationMonth() {
    return this.form.get('cardExpirationMonth');
  }

  get cardNumber() {
    return this.form.get('cardNumber');
  }

  get securityCode() {
    return this.form.get('securityCode');
  }
}

interface DocumentType {
  id: string,
  name: string
}
